<template>
  <scroll-animation-unit 
    class="p-accommodationItem">
    <color-overlay :scale="true" class="p-accommodationItem__image">
      <img :src="post.acf.main_image.url" alt="" class="u-cover">
      <img :src="post.acf.main_image.url" alt="" class="u-cover p-accommodationItem__grayImage">
    </color-overlay>
    <dl class="p-accommodationItem__description">
      <dt>
        <div class="u-mask">
          <router-link :to="`/accommodation/${post.post_name}`" class="p-accommodationItem__button">
            <span>{{ post.acf.acc_name }}</span>
          </router-link>  
        </div>
      </dt>
      <dd class="u-fade">
        <p v-html="post.acf.acc_lead"></p>
        <a 
          v-if="post.acf.acc_booknow_url" 
          :href="post.acf.acc_booknow_url" 
          target="_blank" 
          class="p-accommodationItem__link c-externalLink" 
          data-type="external">
            <template v-if="post.acf.acc_booknow_text">{{ post.acf.acc_booknow_text }}</template>
            <template v-else>Book Now</template>
            
            <i class="icon-external"></i>
        </a>
      </dd>
    </dl>
  </scroll-animation-unit>
</template>

<script>
  /**
   * Share Partial
   */

  export default {
    name: 'accommodation-item',
    props: {
      post: {
        type: Object,
        required: true
      }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/partial/accommodation-item.vue